import * as React from 'react';
import PodiumProps from './type';
import { SvgImage } from '../common';
import './styles.scss';

const Podium = ({
  podium,
  discipline,
}: PodiumProps) => (
  <div className={`podium podium--${discipline}`}>
    <ol className="podium__list">
      {podium.map(({
        firstname,
        lastname,
        team,
        time,
        rank,
      }, index: number) => {
        // If tied, position should be same for both podium items.
        // Fallback to index if rank not present (e.g. for non-country events).
        const position = rank ?? index + 1;

        return (
          <li
            key={`${firstname}-${lastname}`}
            className={`podium__item ${position === 1 ? 'podium__item--first' : ''}`}
          >
            <div className="podium__item-position">
              {position === 1 && (
                <SvgImage title="First place" reference="#icon-cup" />
              )}
              {position > 1 && position}
            </div>
            <div className="podium__item-details">
              <div className="podium__item-firstname">
                {firstname}
              </div>
              <div className="podium__item-lastname">
                {lastname}
              </div>
              <div className="podium__item-team">
                {team}
              </div>
              <div className="podium__item-time">
                {time}
              </div>
            </div>
          </li>
        );
      })}
    </ol>
  </div>
);

export default Podium;
